import { Box, Paper, styled, Typography } from '@mui/material';
import { addOpacity } from 'lib/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface DeliveryPinBoxProps {
    pin?: string;
}

const PinPaper = styled(Paper)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    backgroundColor: addOpacity(theme.palette.text.primary, 0.05),
    color: theme.palette.text.primary,
    padding: theme.spacing(0.5, 1.5)
}));

export const DeliveryPinBox: React.FC<DeliveryPinBoxProps> = ({ pin }) => {
    const { t } = useTranslation();
    if (!pin) {
        return null;
    }
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" pt={1}>
            <Box>
                <Typography sx={{ fontSize: '1.1rem', fontWeight: 700 }}>{t('DELIVERY_PIN')}</Typography>
                <Typography>{t('DELIVERY_PIN_MESSAGE')}</Typography>
            </Box>
            <PinPaper elevation={0}>
                <Typography sx={{ fontSize: '2rem', fontWeight: 'bold' }}>{pin}</Typography>
            </PinPaper>
        </Box>
    );
};
